import React, { Component } from 'react';
import { submit, getFormValues } from 'redux-form';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import _ from 'lodash';
import NewCustomerForm from '../../../shared-components/NewCustomerForm/NewCustomerForm';
import { FormattedMessage, injectIntl, intlShape } from 'react-intl';
import { trackTransition } from '../../../framework/store/FPTI/FPTIActions';
import { triggerEnsightenEvent } from '../../../framework/store/Ensighten/EnsightenActions';
import { ENSIGHTEN_SIGNUP_START, ENSIGHTEN_SIGNUP_FINISH } from '../../../framework/store/Ensighten/EnsightenConstants';
import { submitNewCustomerApplication } from './NewCustomerPageActions';
import StickyContainer from '../../../shared-components/StickyContainer/StickyContainer';
import StickyBody from '../../../shared-components/StickyBody/StickyBody';
import StickyFooter from '../../../shared-components/StickyFooter/StickyFooter';
import CancelUrl, { COMPONENT_STYLE } from '../../components/CancelUrl/CancelUrl';
import { SIGN_UP_FORM_ID, CREDIT_TYPE } from '../../../framework/App/AppConstants';
import { spinnerOpen } from '../../../framework/components/FullPageSpinner/FullPageSpinnerActions';
import Button, {BUTTON_STYLE} from '../../../shared-components/Button/Button';
import './NewCustomerPage.less';
import NewCustomerTermsLabel from './NewCustomerTermsLabel';
import TwoColumnLayout from '../../../framework/components/Templates/TwoColumnLayout/TwoColumnLayout';
import BodyHeader from '../../../shared-components/BodyHeader/BodyHeader';

const LOCALE_PREFIX = 'US/pages/NewCustomerPage/NewCustomerPage';

export class NewCustomerPage extends Component {
    static propTypes = {
        creditType: PropTypes.string.isRequired,
        formValues: PropTypes.object.isRequired,
        intl: intlShape.isRequired,
        onClickContinue: PropTypes.func.isRequired,
        submitCallback: PropTypes.func.isRequired,
        currentPage: PropTypes.string.isRequired,
        emailNotAvailable: PropTypes.bool,
        onComponentDidMount: PropTypes.func.isRequired,
        applicationType: PropTypes.string
    };
    static defaultProps = {
        onComponentDidMount: () => {}
    };

    componentDidMount() {
        this.props.onComponentDidMount();
    }

    handleSubmit = () => {
        const { submitCallback, formValues, applicationType } = this.props;
        return submitCallback({ ...formValues}, applicationType);
    };

    render() {
        const { onClickContinue } = this.props;
        return (
            <TwoColumnLayout pageName="NewCustomerPage">
                <BodyHeader />
                <StickyContainer>
                    <StickyBody>
                        <NewCustomerForm onSubmit={this.handleSubmit} showRequiredCheckbox={true} termsCheckboxLabel={<NewCustomerTermsLabel />} />
                    </StickyBody>
                    <StickyFooter fixToBottom={false} fadedBackground={true}>
                        <div id="action-buttons" className="vx_btn-group">
                            <Button
                                data-automation-id="continue"
                                btnStyle={BUTTON_STYLE.PP_PRIMARY}
                                id="newCustomerContinueBtn"
                                onClick={onClickContinue}
                            >
                                <FormattedMessage
                                    id={`${LOCALE_PREFIX}.continue-application`}
                                />
                            </Button>
                            <CancelUrl
                                componentType={COMPONENT_STYLE.LINK_BUTTON}
                                fptiEvent={{
                                    stateName: 'pp_credit_newcustpage',
                                    transitionName: 'cancel_pp_credit_newcustpage'
                                }}
                            />
                        </div>
                    </StickyFooter>
                </StickyContainer>
            </TwoColumnLayout>
        );
    }
}

export const mapStateToProps = state => ({
    creditType: _.get(state, 'serverData.financingDetails.credit_type', CREDIT_TYPE.CORE),
    user: state.serverData.user,
    formValues: getFormValues(SIGN_UP_FORM_ID)(state) || {},
    financingDetails: state.serverData.financingDetails || {},
    merchantName: state.serverData.merchantName,
    currentPage: state.skeletonPage.currentPage,
    applicationType: _.get(state, 'serverData.applyType')
});


export const mapDispatchToProps = dispatch => ({
    onComponentDidMount() {
        dispatch(trackTransition('pp_credit_newcustpage', 'prepare_pp_credit_newcustpage'));
        dispatch(triggerEnsightenEvent(ENSIGHTEN_SIGNUP_START));
    },
    onClickContinue() {
        dispatch(submit(SIGN_UP_FORM_ID));
    },
    submitCallback(formValues, applicationType) {
        dispatch(spinnerOpen());
        dispatch(trackTransition('pp_credit_newcustpage', 'process_pp_credit_newcustpage', {flow_type: applicationType}));
        dispatch(triggerEnsightenEvent(ENSIGHTEN_SIGNUP_FINISH));
        return dispatch(submitNewCustomerApplication(formValues, LOCALE_PREFIX));
    }
});

export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(NewCustomerPage));
